import {QueryClient, QueryClientProvider} from '@tanstack/react-query'

export const queryClient = new QueryClient({
  defaultOptions: {queries: {retry: 0, refetchOnWindowFocus: false, staleTime: 60_000}},
})

export default function TanstackProvider({children}: {children: React.ReactNode}) {
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
}
